import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from '@bd/bdui-styles/emotion';
import { Image } from '@bd/bdcore-utilities';
import VideoPlayer from '@bd/bdui-videoplayer';
import Carousel from '../components/Carousel';
import { typography } from '../styles';


const styles = css`
  position: relative;
  z-index: 0;
  display: flex;
  height: 250px;
  margin-top: 50px;
  @media (min-width: 560px) {
    height: 300px;
  }
  @media (min-width: 768px) {
    height: 500px;
  }
  @media (min-width: 992px) {
    height: 600px;
    margin-top: 110px;
  }
  @media (min-width: 1440px) {
    height: 700px;

  }
  @media (min-width: 1600px) {
    height: 800px;
  }
  .InsideHeader_imageWrapper {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-position: center center;
  }
  .InsideHeader_image {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    @supports (object-fit: cover) and (object-position: center center) {
      position: static;
      min-width: 0;
      min-height: 0;
      margin: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center center;
    }
  }
  .InsideHeader_titleWrapper {
    position: relative;
    z-index: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
  }

  .Title {
    font-family: ${typography.Serif};
    font-style: italic !important;
    font-weight: 500;
    font-size: 26px;
    text-align: center;
    color: white;
    text-shadow: 0 3px 5px rgba(0,0,0,0.30);
    display: block;
    line-height: normal;
    @media (min-width: 768px) {
      font-size: 28px;
    }
    @media (min-width: 992px) {
      font-size: 36px;
      margin: 0;
    }
    @media (min-width: 1440px) {
      font-size: 40px;
    }
  }

  .Subtitle {
    display: block;
    font-family: ${typography.Serif};
    font-weight: 300 !important;
    font-size: 45px;
    color: #FFFFFF;
    text-align: center;
    font-style: none !important;
    text-transform: uppercase;
    text-shadow: 0 3px 6px rgba(0,0,0,0.30);
    margin: 5px auto;
    display: block;
    position: relative;
    @media (min-width: 560px) {
      font-size: 50px;
    }
    @media (min-width: 768px) {
      font-size: 60px;
    }
    @media (min-width: 992px) {
      font-size: 95px;
      letter-spacing: 3px;
      margin: 15px auto;
    }
  }

`;

const videoCSS = css`
  position: absolute;
  width: 100%;
  padding-top: 56.25%;
  top: 0;
  bottom: 0;
  overflow: hidden;
  @media (min-width: 1600px) {
    padding: 50% 0 0 0;
    background-position: center bottom;
  }
  video {
    object-fit: cover;
  }
`;


function HeroVideo({ background, className,
  title, subtitle, video, carouselSlides }) {
  return (
    <div className={`InsideHeader ${cx(styles, className)}`} id="page-content">
      <div className="InsideHeader_imageWrapper">
        {
          !video && !carouselSlides &&
          <Image
            className="InsideHeader_image"
            src={background}
            alt=""
          />
        }
        {
          !video && carouselSlides &&
          <Carousel
            typeLabel="Photos"
            className="InsideHeader_image"
            items={carouselSlides}
            autoplay
            canEnlarge={false}
            mainImageProps={{
              width: 2000,
              height: 1125,
              exact: true,
            }}
            thumbnailImageProps={{
              width: 600,
              height: 400,
              exact: true,
            }}
          />
        }
        {
          video &&
          <VideoPlayer
            playing
            playsinline
            muted
            loop
            playbackRate={0.85}
            className={videoCSS}
            url={video}
          />
        }
      </div>
      <div className="InsideHeader_titleWrapper">
        <div className="container animated zoomIn">
          <h1 className="TitleWrapper">
            <span className="Title">{title}</span>
            <span className="Subtitle">{subtitle}</span>
          </h1>
        </div>
      </div>
    </div>
  );
}

HeroVideo.propTypes = {
  background: PropTypes.node,
  carouselSlides: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  subtitle: PropTypes.string,
  video: PropTypes.string,
};

HeroVideo.defaultProps = {
  background: undefined,
  className: undefined,
  subtitle: undefined,
  video: undefined,
  carouselSlides: undefined,
  title: '',
};

export default HeroVideo;



// WEBPACK FOOTER //
// ./src/components/HeroVideo.js